import { useState } from "react";
import { LOGO_URL } from "@/constants";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ShoppingBag } from "lucide-react";
import { useBasket } from "@/context/BasketContext";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { count } = useBasket();
  const home = pathname === "/";

  const LINKS = [
    { label: "Story", href: home ? "#story" : "/#story" },
    { label: "Journey", href: home ? "#journey" : "/#journey" },
    { label: "Products", href: "/products", route: true },
    { label: "Recipes", href: "/recipes", route: true },
    { label: "Videos", href: home ? "#videos" : "/#videos" },
    { label: "Contact", href: home ? "#contact" : "/#contact" },
  ];

  const linkCls =
    "font-body font-semibold text-[12px] uppercase tracking-[0.18em] text-white/75 hover:text-kera-gold transition-colors duration-300";

  const renderLink = (l, cls, testid) =>
    l.route ? (
      <Link key={l.label} to={l.href} data-testid={testid} className={cls} onClick={() => setOpen(false)}>
        {l.label}
      </Link>
    ) : (
      <a key={l.label} href={l.href} data-testid={testid} className={cls} onClick={() => setOpen(false)}>
        {l.label}
      </a>
    );

  const basketLink = (
    <Link
      to="/basket"
      data-testid="nav-basket-link"
      className="relative inline-flex items-center justify-center h-9 w-9 rounded-full border border-white/25 text-white hover:border-kera-gold hover:text-kera-gold transition-colors duration-300"
      aria-label="Enquiry list"
    >
      <ShoppingBag size={15} />
      {count > 0 && (
        <span className="absolute -top-1.5 -right-1.5 h-4.5 min-w-[18px] px-1 rounded-full bg-kera-gold text-black text-[10px] font-mono flex items-center justify-center" data-testid="nav-basket-count">
          {count}
        </span>
      )}
    </Link>
  );

  return (
    <header className="relative z-50 bg-black border-b border-kera-gold/25" data-testid="navbar">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="nav-brand-logo">
          <img src={LOGO_URL} alt="KERA — From God's Own Country" className="h-9 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => renderLink(l, linkCls, `nav-link-${l.label.toLowerCase()}`))}
          {basketLink}
          <Link
            to="/trade"
            data-testid="nav-trade-link"
            className="font-body font-semibold text-[12px] uppercase tracking-[0.18em] bg-kera-gold text-black rounded-full px-5 py-2 hover:bg-kera-goldlight transition-colors duration-300"
          >
            Trade
          </Link>
        </nav>
        <div className="md:hidden flex items-center gap-3">
          {basketLink}
          <button className="text-white" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="nav-mobile-toggle">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-md border-t border-kera-gold/20 px-6 py-5 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => renderLink(l, "font-body font-semibold text-sm uppercase tracking-[0.18em] text-white/75", `nav-mobile-${l.label.toLowerCase()}`))}
          <Link to="/trade" className="font-body font-semibold text-sm uppercase tracking-[0.18em] text-kera-gold" onClick={() => setOpen(false)}>
            Trade — Join / Login
          </Link>
        </div>
      )}
    </header>
  );
}
